import { SelectOption } from '@frontend/basic-forms';
import { useAppSelector } from '@frontend/common';
import { IoTEnumClient } from '@frontend/iot/api';
import { IoTAction, IoTActionName } from '@frontend/iot/types';
import { fetchGeneralWorkflowActions, workflowSharedStore } from '@frontend/workflow/redux';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { IoTActionSelectProps } from './iot-action-select.component';

interface ViewProps {
    options: SelectOption<IoTActionName>[];
}

const useIoTActionSelect = (props: IoTActionSelectProps): ViewProps => {
    const [actions, changeActions] = useState<string[]>([]);
    const workflowSharedState = useAppSelector(useSelector, workflowSharedStore);

    useEffect(() => {
        props.dispatch && props.dispatch(fetchGeneralWorkflowActions());
        IoTEnumClient.fetchIoTActions().then(changeActions);
    }, []);

    const options = useMemo(() => {
        if (!actions || !workflowSharedState.generalWorkflowActions) return [];
        return [...actions, ...workflowSharedState.generalWorkflowActions].map((action) => {
            const found = IoTAction.ALL.find((t) => t.value.toString() === action);
            if (found) return { value: found.value.toString(), label: found.value.toString(), display: found.displayName };
            else
                return {
                    value: action,
                    label: action.replace(/_/g, ' ')
                };
        });
    }, [actions, workflowSharedState.generalWorkflowActions]);

    return { options };
};

export default useIoTActionSelect;
